














import { resolveCategory } from '~/utils/category'
import { LinkType } from '~/models/search/types'
import { ciDeals } from '~/icons/source/thin/deals'
import { categoriesIconsMappings } from '~/constants/category/icon'
import FeedSidebarIconContainer from '~/components/car/classifieds/index/feeds/sidebar/FeedSidebarIconContainer.vue'
import { ciTradesMatch } from '~/icons/source/regular/trades-match'
import { ciBlackFriday } from '~/icons/source/brand/black-friday'
import { CategoryId } from '~/models/category/types'
import { ciJobs } from '~/icons/source/thin/jobs'
import { ciRentals } from '~/icons/source/thin/rentals'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciMagnifyingGlass } from '~/icons/source/solid/magnifying-glass'
import { ciStar } from '~/icons/source/solid/star'
import { ciMarketplace } from '~/icons/source/thin/marketplace'
import { ciBicycles } from '~/icons/source/thin/bicycles'
import { ciRealEstate } from '~/icons/source/thin/real-estate'

export default defineComponent({
  components: {
    FeedSidebarIconContainer
  },
  props: {
    categoryIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    inSidebar: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    noColors: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      if (!this.type) {
        return {
          icon: resolveCategory(categoriesIconsMappings, this.categoryIds)
        }
      }

      switch (this.type) {
        case LinkType.PROMOTED: {
          return {
            icon: ciStar
          }
        }
        case LinkType.ALL: {
          return {
            icon: ciMagnifyingGlass
          }
        }
        case LinkType.DEALS: {
          return {
            icon: ciDeals
          }
        }
        case LinkType.BLACK_FRIDAY: {
          return {
            icon: ciBlackFriday,
            class: 'black-friday'
          }
        }
        case LinkType.TRADES: {
          return {
            icon: ciTradesMatch,
            class: 'tw-text-[1.5rem] tw-ml-1'
          }
        }
        case LinkType.JOBS: {
          return {
            icon: ciJobs
          }
        }
        case LinkType.XYMA: {
          return {
            icon: ciMarketplace
          }
        }
        case LinkType.REAL_ESTATE: {
          return {
            icon: ciRealEstate
          }
        }
        case LinkType.RENTALS: {
          return {
            icon: ciRentals
          }
        }
        case String(CategoryId.BICYCLES): {
          return {
            icon: ciBicycles
          }
        }
      }
      return {
        icon: resolveCategory(categoriesIconsMappings, this.categoryIds)
      }
    }
  }
})
